import { I18n } from '@calendly/i18n'

import { SearchInput } from './search_input'

export const OwnersSearch = ({ selectedIds, setSelectedIds }) => (
  <SearchInput
    title={I18n.t('publisher.event_types.filters.titles.owners')}
    selectedIds={selectedIds}
    setSelectedIds={setSelectedIds}
  />
)
